import { render, staticRenderFns } from "./TicketChangeCompanyDialog.vue?vue&type=template&id=2d70f1a2"
import script from "./TicketChangeCompanyDialog.js?vue&type=script&lang=js&external"
export * from "./TicketChangeCompanyDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports